import { AssessmentPage, AssessmentPageQuery, Cohort } from '@edwin-group/cj-graphql';
import { create } from 'zustand';

interface AssessmentState {
  cohortToUpdate: Cohort | null;
  cohorts: Cohort[];
  assessmentPage: AssessmentPage | null;
  setAssessmentPage: (assessmentPage: AssessmentPageQuery) => void;
  setCohorts: (cohorts: Cohort[]) => void;
  setCohortToUpdate: (cohort: Cohort | null) => void;
}

export const useAssessmentStore = create<AssessmentState>((set) => ({
  cohortToUpdate: null,
  cohorts: [],
  assessmentPage: null,
  setAssessmentPage: (assessmentPage: AssessmentPageQuery) => {
    set({ assessmentPage: assessmentPage?.assessmentPage as AssessmentPage });
  },
  setCohorts: (cohorts: Cohort[]) => {
    set({ cohorts });
  },
  setCohortToUpdate: (cohort: Cohort | null) => {
    set({ cohortToUpdate: cohort });
  },
}));
